
import React, { useEffect, useState } from "react";
import "./EventGallery.css";

/* 🔥 IMPORT ALL IMAGES FROM src/images */
import img1 from "../images/img13.jpg";
import img2 from "../images/img14.jpg";
import img3 from "../images/img15.jpg";
import img4 from "../images/img16.jpg";
import img6 from "../images/img6.jpg";
import img7 from "../images/img23.jpg";
import img8 from "../images/img63.jpg";
import img9 from "../images/img64.jpg";
import img10 from "../images/img65.jpg";
import img11 from "../images/img66.jpg";
import img12 from "../images/img67.jpg";
import img13 from "../images/img28.jpg";
import img14 from "../images/img57.jpg";
import img15 from "../images/img43.jpg";
import img16 from "../images/img45.jpg";
import img17 from "../images/img27.jpg";
import img18 from "../images/img58.jpg";
import img21 from "../images/img11.jpg";
import img22 from "../images/img22.jpg";
import img23 from "../images/img68.jpg";
import img24 from "../images/img79.jpg";
import img25 from "../images/img69.jpg";
import img26 from "../images/img70.jpg";
import img27 from "../images/img72.jpg";
import img28 from "../images/img73.jpg";
import img29 from "../images/img74.jpg";
import img30 from "../images/img75.jpg";
import img31 from "../images/img71.jpg";
import img32 from "../images/img76.jpg";
import img33 from "../images/img77.jpg";
import img34 from "../images/img78.jpg";
import img35 from "../images/img18.jpg";
import img36 from "../images/img19.jpg";
import img37 from "../images/img20.jpg";
import img38 from "../images/img21.jpg";
import img39 from "../images/img7.jpg";
import img40 from "../images/img8.jpg";
import img41 from "../images/img9.jpg";
import img42 from "../images/img10.jpg";
import img43 from "../images/img12.jpg";
import img44 from "../images/new1.jpg";
import img45 from "../images/new2.jpg";
import img46 from "../images/new3.jpg";
import img47 from "../images/img29.jpg";
import img48 from "../images/img34.jpg";
import img49 from "../images/new4.jpg";
import img50 from "../images/new5.jpg";
import img51 from "../images/new6.jpg";

/* 🔥 GALLERY DATA */
const galleryBlocks = [
  {
    images: [img1, img2, img3, img4, img6, img7, img8, img9, img10, img11, img12],
    paragraph: " ग्रंथालय उद्घाटनाचे मान्यवर श्री. चंद्रकांत दादा पाटील, उच्च व तंत्रशिक्षण मंत्री, आणि माननीय डॉ. विनयरावजी कोरे (सावकर), आमदार- शाहूवाडी पन्हाळा तसेच गोकुळ संचालक अमरसिंह पाटील भाऊ यांच्या हस्ते संपन्न झाले.",
  },
  {
    images: [img13, img14, img15, img16],
    paragraph: " सन २०२१ च्या पुराच्या काळात ग्रंथालयाने पूरग्रस्त नागरिकांना कपडे, अन्नधान्य व औषधांचे वाटप केले. तसेच, बालदिनाच्या निमित्ताने लहान मुलांसाठी ग्रंथालयाला तसेच शासकीय रुग्णालयाला भेट देण्याचे आयोजन करण्यात आले.",
  },
  {
    images: [img17, img18],
    paragraph: " ग्रंथालयाने घरगुती व लघु उद्योगांबाबत मार्गदर्शन शिबिर आयोजित केले.",
  },
  {
    images: [img21, img22, img23, img24, img25, img26],
    paragraph: " ग्रंथालयाच्या वर्धापन दिनानिमित्त वीर विनायक सावरकर आणि ग्रंथालये या विषयावर cine अभिनेते व प्रख्यात वक्ते श्री शरदजी पोंक्षे सर यांचे व्याख्यान आयोजित करण्यात आले.",
  },
  {
    images: [img27, img28, img29, img30],
    paragraph: "ग्रंथ दिंडी उपक्रम मोठ्या उत्साहात पार पडला. वाचनसंस्कृतीचा प्रसार व ज्ञानाचे महत्त्व समाजापर्यंत पोहोचवण्यासाठी विद्यार्थी व नागरिकांनी सहभाग घेत जनजागृती केली..",
  },
  {
    images: [img35, img36, img37, img38, img31, img32, img33, img34],
    paragraph: "कोडोली ग्रामपंचायतीतर्फे ग्रंथ पूजन सोहळा श्रद्धा व उत्साहात संपन्न झाला. ज्ञानसंवर्धन व वाचनसंस्कृतीच्या जतनासाठी या उपक्रमाचे आयोजन करण्यात आले असून ग्रामस्थांनी उत्स्फूर्त सहभाग नोंदविला.",
  },
  {
    images: [img39, img40, img41, img42, img43, img44, img45, img46],
    paragraph: "नवरात्रोत्सवानिमित्त आयोजित हळदी-कुंकू व नारीशक्ती सन्मान सोहळ्याच्या प्रसंगी मा. प्रमोदजी महाजन यांच्या कन्या खासदार तसेचं माजी राष्ट्रीय भाजपा मोर्चा अध्यक्ष पूनमजी महाजन ताई साहेब यांच्या हस्ते दीपप्रज्वलन करण्यात आले.",
  },
  {
    images: [img47, img48],
    paragraph: "जागतिक पर्यावरण दिनाच्या निमित्ताने वृक्षारोपण कार्यक्रम उत्साहात पार पाडण्यात आला. पर्यावरण संवर्धनाचा संदेश देत नागरिकांनी या उपक्रमात उत्स्फूर्त सहभाग नोंदविला.",
  },
  {
    images: [img49, img50, img51],
    paragraph: "कोडोली ग्रामपंचायतीतर्फे गरीब गरजू विद्यार्थ्यांना मोफत कपडे व खाऊ वाटप करण्यात आले व बालसंस्कार शिबिराचे आयोजन करण्यात आले होते आणि त्यामध्ये विद्यार्थी आणि नागरिकांचा चांगला सहभाग होता.",
  },
];

const EventGallery = () => {
  const [lightbox, setLightbox] = useState({
    isOpen: false,
    blockIndex: 0,
    imageIndex: 0,
  });
  
  
  const [animateKey, setAnimateKey] = useState(0);

  useEffect(() => {
    const blocks = document.querySelectorAll(".gallery-block");
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show-block");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: "0px 0px -50px 0px" }
    );

    blocks.forEach((block) => observer.observe(block));
    return () => observer.disconnect();
  }, []);

  
  const openLightbox = (blockIdx, imgIdx) => {
    setLightbox({ isOpen: true, blockIndex: blockIdx, imageIndex: imgIdx });
    setAnimateKey(Math.random());
  };

  const closeLightbox = () => {
    setLightbox((prev) => ({ ...prev, isOpen: false }));
  };

  const showNext = () => {
    const currentBlock = galleryBlocks[lightbox.blockIndex];
    setLightbox((prev) => ({
      ...prev,
      imageIndex: (prev.imageIndex + 1) % currentBlock.images.length,
    }));
    setAnimateKey(Math.random()); 
  };

  const showPrev = () => {
    const currentBlock = galleryBlocks[lightbox.blockIndex];
    setLightbox((prev) => ({
      ...prev,
      imageIndex: (prev.imageIndex - 1 + currentBlock.images.length) % currentBlock.images.length,
    }));
    setAnimateKey(Math.random());
  };

  useEffect(() => {
    if (!lightbox.isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === "ArrowRight") showNext();
      if (e.key === "ArrowLeft") showPrev();
      if (e.key === "Escape") closeLightbox();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [lightbox.isOpen, lightbox.imageIndex]);

  return (
    <section className="event-gallery-section">
      <div className="gallery-background-overlay"></div>

      <div className="gallery-content-container">
        <h2 className="gallery-title">“उपक्रम आणि कार्यक्रम”</h2>

        {galleryBlocks.map((block, blockIdx) => (
          <div className="gallery-block" key={blockIdx}>
            <div className="gallery-images">
              {block.images.map((img, imgIdx) => (
                <div className="gallery-image" key={imgIdx}>
                  
                  <img
                    src={img}
                    alt="कार्यक्रम"
                    onClick={() => openLightbox(blockIdx, imgIdx)}
                  />
                </div>
              ))}
            </div>

            {block.paragraph && (
              <p className="gallery-paragraph">{block.paragraph}</p>
            )}
          </div>
        ))}
      </div>

      {/* MUI INSPIRED ULTRA-SMOOTH MODAL */}
      {lightbox.isOpen && (
        <div className="image-modal animate-fade-in" onClick={closeLightbox}>
          
          <button className="close-btn-fixed" onClick={closeLightbox}>
            ✕
          </button>

          <button className="nav-btn prev-btn" onClick={(e) => { e.stopPropagation(); showPrev(); }}>
            <span className="arrow-icon">&#10094;</span>
          </button>

          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <img 
              key={animateKey} /* Key बदलल्यामुळे MUI सारखा प्रत्येक फोटोवर री-फेड इफेक्ट दिसेल */
              src={galleryBlocks[lightbox.blockIndex].images[lightbox.imageIndex]} 
              alt="popup" 
              className="modal-main-img animate-scale-up"
            />
          </div>

          <button className="nav-btn next-btn" onClick={(e) => { e.stopPropagation(); showNext(); }}>
            <span className="arrow-icon">&#10095;</span>
          </button>
        </div>
      )}
    </section>
  );
};

export default EventGallery;